const addressUtils = require('@kathondvla/sri-client/address-utils');
const dateUtils = require('@kathondvla/sri-client/date-utils');

const isValidZipCode = function (zipCode, subCityObject) {
  for(let zc of subCityObject.zipCodes){
    if(zc === zipCode) {
      return true;
    }
  };
  return false;
};

function makeid() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

const initialValue = {
  street: null,
  houseNumber: undefined,
  zipCode: null,
  subCity: null,
  city: null,
  subCityHref: null,
  streetHref: undefined,
  cityHref: null,
  country: 'be'
};

class KovAddressForm {
  constructor($scope, $timeout) {
    'ngInject';
    this.$scope = $scope;
    this.debounce = 750;
    this.$timeout = $timeout;

    this.zipCodeSubCityMap = {};
    this.address = { ...initialValue };
    this.errors = {
      zipCode: [],
      subCity: [],
      street: [],
      houseNumber: [],
      mailboxNumber: [],
      incomplete: [],
      foreignZipCode: [],
      foreignCity: [],
    };
  }

  $onInit() {
    initialValue.countryHref = '/sam/commons/countries/be';
    this.address.countryHref = initialValue.countryHref;
    this.validate(false, true);

    // broadcast event from component that uses form to indicate that a new entity is selected and form needs to be reset (no errors from previous enitity should be left hanging)
    this.$scope.$on('resetFormValidation', () => {
      this.validatedSinceReset = false;
      this.$timeout(() => {
        // give time for bindings to be set
        if (!this.validatedSinceReset) {
          // When a new entity is loaded in the form and this formcomponent is empty or hidden on the screen we need to make sure it is validated again.
          this.validate(false, true);
        }
      }, 1500);
    });
  }

  getSubCitiesForZipCode(zipCode) {
    if(!this.zipCodeSubCityMap[zipCode]) {
      this.zipCodeSubCityMap[zipCode] = this.sSriClient.getAll(
        '/sam/commons/subcities',
        { zipCode: zipCode, expand: 'results.city' }
      );
    }
    return this.zipCodeSubCityMap[zipCode];
  }

  clearAddress() {
    this.address = Object.assign({}, initialValue);
  }

  $onChanges(bindings){
    // console.log('bindings', bindings)
    if(bindings.sAddress && bindings.sAddress.currentValue) {
      this.address.street = bindings.sAddress.currentValue.street;
      this.address.houseNumber = bindings.sAddress.currentValue.houseNumber;
      this.address.mailboxNumber = bindings.sAddress.currentValue.mailboxNumber;
      this.address.zipCode = bindings.sAddress.currentValue.zipCode;
      this.address.subCity = bindings.sAddress.currentValue.subCity;
      this.address.city = bindings.sAddress.currentValue.city;
      this.address.streetHref = bindings.sAddress.currentValue.streetHref;
      this.address.subCityHref = bindings.sAddress.currentValue.subCityHref;
      this.address.cityHref = bindings.sAddress.currentValue.cityHref;
      this.address.country = bindings.sAddress.currentValue.country;
      this.address.countryHref = bindings.sAddress.currentValue.countryHref;
      initialValue.countryHref = this.address.countryHref || initialValue.countryHref;
      initialValue.country = this.address.country || initialValue.country;
      this.validate(false, true);
      if(bindings.sAddress.currentValue.subCityHref && (!this.subCity || this.subCity.$$meta.permalink !== bindings.sAddress.currentValue.subCityHref)) {
        this.sSriClient.get(bindings.sAddress.currentValue.subCityHref, { expand: 'results.city' }).then(subCity => {
          this.subCity = subCity;
          this.getStreetsForSubCity();
          this.validate(false, true);
        });
      } else if (!bindings.sAddress.currentValue.subCityHref) {
        // TODO try to lookUp the subCityHref
        console.log('The address has no subCityHref');
      }
      if(bindings.sAddress.currentValue.streetHref && (!this.street || this.street.$$meta.permalink !== bindings.sAddress.currentValue.streetHref)) {
        this.sSriClient.get(bindings.sAddress.currentValue.streetHref).then(street => {
          this.street = street;
          this.validate(false, true);
        });
      } else if (!bindings.sAddress.currentValue.streetHref) {
        //TODO try to lookup the streetHref
        console.log('The address has no streetHref');
      }
      /*this.$scope.$emit('kovFormElemChanged', {
        value: bindings.sModel.currentValue,
        errors: validationErrors
      });*/
    }
    if(bindings.sAddress && !bindings.sAddress.currentValue && bindings.sAddress.previousValue) {
      this.address = { ...initialValue };
    }
  }

  async getMultipleSubCitiesForSameZipCode(zipCode) {
    if (zipCode.match('^[1-9][0-9]{3}$') && (!this.subCity || !isValidZipCode(zipCode, this.subCity)) ) {
      const subCities = await this.getSubCitiesForZipCode(zipCode);
      if(subCities.length > 1 && this.focus === 'zipCode') {
        return subCities.map(sc => Object.assign(sc, {
          name: sc.name.split('(')[0].trim(),
          $displayName: sc.name.split('(')[0].trim() + sc.city.$$expanded.name === sc.name.split('(')[0].trim() ? '' : ' (' + sc.city.$$expanded.name + ')'
        }));
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  async getSubCitySuggestions(subCity) {
    const searchParams = { nameContains: subCity, expand: 'results.city', limit: 20 };
    const subCities = await this.sSriClient.getList('/sam/commons/subcities', searchParams);
    if (this.focus === 'subCity') {
      const result = [];
      subCities.forEach(subCity => {
        subCity.zipCodes.forEach(zipCode => {
          const name = subCity.name.split('(')[0].trim();
          result.push(Object.assign({}, subCity, {
            $$zipCode: zipCode,
            name: name,
            $display: zipCode + ', ' + name + (subCity.city.$$expanded.name === name ? '' : ` (${subCity.city.$$expanded.name})`)
          }))
        });
      });
      return result;
    } else {
      return Promise.resolve([]);
    }
  }

  async getStreetSuggestions(street) {
    if (this.focus === 'street') {
      const searchParams = { nameContains: street, city: this.subCity ? this.subCity.city.href : undefined, endDateAfter: dateUtils.getNow(), expand: 'results.city' };
      const streets = await this.sSriClient.getList('/sam/commons/streets', searchParams);
      if(this.subCity && this.subCity.streets) {
        const exactMatches = this.subCity.streets.filter(scStreet => addressUtils.isStreetNameMatch(scStreet.name, this.address.street));
        return [...exactMatches, ...streets.filter(street => !exactMatches.some(match => match.$$meta.permalink === street.$$meta.permalink))];
      } else {
        return streets;
      }
    } else {
      return [];
    }
  }

  getStreetsForSubCity() {
    const cityHref = this.subCity.city.href;
    this.sSriClient.getAll('/sam/commons/streets', { city: cityHref, limit: 5000, endDateAfter: dateUtils.getNow() }).then(streets => {
      if(streets[0] && streets[0].city.href === cityHref) {
        this.subCity.streets = streets.map(street => {
          return Object.assign(street, {
            $$meta: street.$$meta,
            city: {
              href: this.subCity.city.href,
              $$expanded: this.subCity.city.$$expanded
            }
          });
        });
      }
    });
  }

  setSubCity(subCityObject) {
    this.address.subCity = subCityObject.name;
    this.address.city = subCityObject.city.$$expanded.name;
    if (!subCityObject.city.$$expanded.nisCode) {
      subCityObject.city.$$expanded.nisCode = subCityObject.city.$$expanded.key;
    }
    if((this.street && this.street.city.href !== subCityObject.city.href) || (!this.street && this.subCity && subCityObject.key !== this.subCity.key)) {
      this.address.street = null;
      this.address.streetHref = undefined;
      this.address.houseNumber = null;
      this.address.mailboxNumber = undefined;
      this.street = null;
    }
    this.subCity = subCityObject;
    this.address.subCityHref = subCityObject.$$meta.permalink;
    this.address.cityHref = subCityObject.city.href;
    if(this.address.zipCode && this.address.zipCode.match(/^\d{4},\s.*$/)) {
      this.address.zipCode = this.address.zipCode.substring(0, 4);
    }
    if(!this.address.zipCode || !isValidZipCode(this.address.zipCode, subCityObject)) {
      this.address.zipCode = subCityObject.zipCodes[0];
    }

    this.validate();
    this.getStreetsForSubCity();
  }

  setStreet(streetObject, applyScope) {
    console.log('Street is set to', streetObject);
    this.address.street = streetObject.name;
    if (this.sStoreStreetHref) {
      this.address.streetHref = streetObject.$$meta.permalink;
    }
    this.street = streetObject;
    this.validate(applyScope);
  }

  async onZipCodeChange() {
    if (this.address.zipCode.match(/^[1-9][0-9]{3}$/g)) {
      const subCities = await this.getSubCitiesForZipCode(this.address.zipCode);
      if(subCities.length === 1) {
        this.setSubCity(subCities[0]);
      } else {
        await this.validate();
      }
    } else if (this.address.zipCode) {
      await this.validate();
    }
    this.zipCodeTyping = false;
    this.zipCodeDirty = true;
  }

  onZipCodeBlur() {
    this.focus = null;
    if (!this.address.zipCode && this.oldZipCode) {
      this.address = Object.assign({}, initialValue);
      if (this.address.country === 'be') {
        this.validate();
      }
    }
  }

  onZipCodeFocus() {
    this.focus = 'zipCode';
    this.oldZipCode = this.address.zipCode;
  }

  updateSubCity(timeout) {
    if (!this.address.subCity) {
      if(this.oldSubCity) {
        this.sAddress = Object.assign({}, initialValue);
        this.validate();
      }
    } else {
      setTimeout( async () => {
        if(!this.subCity || this.subCity.name !== this.address.subCity) {
          console.log('The user left subCity input without selecting a subCity from the list!');
          this.subCity = null;
          const subCities = await this.sSriClient.getList('/sam/commons/subcities', {
            name: this.address.subCity,
            limit: 15,
            expand: 'results.city',
          });
          const exactMatches = subCities.filter(subCity => subCity.name.replace(/\s?\(.+\)/g, '').toLowerCase() === this.address.subCity.toLowerCase());
          if (exactMatches.length === 1) {
            if (!exactMatches[0].$$zipCode) {
              exactMatches[0].$$zipCode = exactMatches[0].zipCodes[0];
            }
            this.setSubCity(exactMatches[0], true);
          } else {
            this.validate(true);
          }
        }
      }, timeout);
    }
  }

  onSubCityChange() {
    this.updateSubCity(15000); // see onStreetChange
  }

  onSubCityBlur() {
    this.focus = null;
    // When you leave the subcity input field when not selecting a subCity from the typeahead.
    // Need timeout because first setSubCity needs to run if called by selecting from typeahead.
    this.updateSubCity(250)
  }

  onSubCityFocus() {
    this.focus = 'subCity';
    this.oldSubCity = this.address.subCity;
  }

  updateStreet(timeout) {
    if (!this.address.street) {
      this.validate(true);
    } else {
      setTimeout( async () => {
        if(!this.street || this.street.name !== this.address.street) {
          console.log('The user left street input without selecting a street from the list!');
          this.street = null;
          this.address.streetHref = undefined;
          let streets = this.subCity.streets;
          // used to be streets is undefined and the code below, but I think it will always work now that it is sam
          /* if(this.subCity && this.subCity.streets) {
            streets = this.subCity.streets;
          } else if(this.address.zipCode && this.address.zipCode.match(/^[1-9][0-9]{3}$/g)) {
            // will only work to vos (zipcode param does not exist in sam) but this.subCity.streets is just always filled in => obsolete
            streets = await this.sSriClient.getAll('/sam/commons/streets', { name: this.address.street, zipCode: this.address.zipCode, limit: 50 });
          } */
          const exactMatches = streets.filter(street => addressUtils.isStreetNameMatch(street.name, this.address.street));
          if (exactMatches.length === 1) {
            const street = exactMatches[0];
            if (this.sStoreStreetHref) {
              this.address.streetHref = street.$$meta.permalink;
              console.log('streetHref set to ' + this.address.streetHref);
            }
            this.street = street;
            this.validate(true);
          }
        }
      }, timeout);
    }
  }

  onStreetChange() {
    // console.log('street changed to ' + this.address.street);
    this.updateStreet(15000); // if the user stays for 15 seconds in the streetfield without selecting or leaving it we are going to update the street value to what he has typed up till now
  }

  onStreetBlur() {
    this.focus = null;
    // When you leave the street input field when not selecting a street from the typeahead.
    // Need timeout because first setStreet needs to run if called by selecting from typeahead.
    if (this.address.country === 'be') {
      this.updateStreet(250);
    }
  }

  onStreetFocus() {
    this.focus = 'street';
  }

  onHouseNumberChange() {
    this.validate(true);
    this.houseNumberTyping = false;
    this.houseNumberDirty = true;
  }

  onHouseNumberFocus() {
    this.focus = 'houseNumber';
  }

  onHouseNumberBlur() {
    this.focus = null;
  }

  onMailboxNumberChange(e, mailboxNumber) {
    // this.address.mailboxNumber = mailboxNumber;
    this.validate(true);
    this.mailboxNumberTyping = false;
    this.mailboxNumberDirty = true;
  }

  onMailboxNumberFocus() {
    this.focus = 'mailboxNumber';
  }

  onMailboxNumberBlur() {
    this.focus = null;
  }

  validateEmptyProperty(property, label, errors) {
    if(this.sRequired) {
      errors[property].push({
        code: 'required',
        message: label + ' is verplicht'
      });
    } else if(this.address.zipCode || this.address.subCity || this.address.street || this.address.houseNumber) {
      errors.incomplete.push(property);
    }
  }

  async validate(applyScope, initialisationPhase) {
    this.validatedSinceReset = true;
    let doingAsyncCall = false;
    const errors = {
      zipCode: [],
      subCity: [],
      street: [],
      houseNumber: [],
      mailboxNumber: [],
      foreignCity: [],
      incomplete: [],
    };
    // street
    if (!this.address.street) {
      this.validateEmptyProperty('street', 'De straat', errors);
    }
    // houseNumber
    if (!this.address.houseNumber) {
      this.validateEmptyProperty('houseNumber', 'Het huisnummer', errors);
    }
    // zipCode
    if(!this.address.zipCode) {
      this.validateEmptyProperty('zipCode', 'De Postcode', errors);
    } else if (this.address.country === 'be') {
      if(!this.address.zipCode.match(/^[1-9][0-9]{3}$/g)) {
        errors.zipCode.push({
          code: 'pattern',
          message: this.address.zipCode + ' is geen geldige postcode'
        });
      } else {
        doingAsyncCall = true;
        const subCities = await this.getSubCitiesForZipCode(this.address.zipCode);
        if(subCities.length === 0) {
          errors.zipCode.push({
            code: 'subcity.mismatch',
            message: 'Er bestaat geen Belgische gemeente met deze postcode.'
          });
        }
        if (this.subCity && !this.subCity.zipCodes.some(zipCode => zipCode === this.address.zipCode)) {
          errors.zipCode.push({
            code: 'conflicting.subcity',
            message: this.address.zipCode + ' is geen geldige postcode voor ' + this.address.subCity
          });
        }
      }
    } else if (this.address.country === 'nl') {
      if (/^\d{4}[A-Za-z]{2}$/i.test(this.address.zipCode)) {
        this.address.zipCode = `${this.address.zipCode.slice(0, 4)} ${this.address.zipCode.slice(4).toUpperCase()}`;
      } else if (!this.address.zipCode.match(/^[1-9][0-9]{3}\s[a-zA-Z]{2}$/g)) {
        errors.zipCode.push({
          code: 'pattern',
          message: this.address.zipCode + ' is geen geldige postcode'
        });
      }
    }
    // subCity / Foreign City
    if (this.address.country === 'be') {
      if (!this.address.subCity) {
        this.validateEmptyProperty('subCity', 'De gemeente', errors);
      } else if(!this.subCity) {
        errors.subCity.push({
          code: 'subcity.does.not.exist',
          message: this.address.subCity + ' is geen gekende gemeente. Zoek opnieuw en selecteer een gemeente uit de lijst van suggesties.'
        });
      }
    } else {
      if (!this.address.city) {
        this.validateEmptyProperty('foreignCity', 'De gemeente', errors);
      }
    }
    // houseNumber
    if (this.address.houseNumber && !this.address.houseNumber.match(/^.*[a-zA-Z0-9].*$/)) {
      errors.houseNumber.push({
        code: 'house.number.invalid',
        message: 'Het huisnummer moet minstens een cijfer of een letter bevatten.'
      });
    }
    // mailboxNumber
    if (this.address.mailboxNumber && !this.address.mailboxNumber.match(/^.*[a-zA-Z0-9].*$/)) {
      errors.mailboxNumber.push({
        code: 'mailbox.number.invalid',
        message: 'Het busnummer moet minstens een cijfer of een letter bevatten.'
      });
    }
    this.errors = errors;
    const output = [...errors.zipCode, ...errors.subCity, ...errors.street, ...errors.houseNumber, ...errors.mailboxNumber, ...errors.foreignCity];
    console.log('Address validation errors', output);
    if (errors.incomplete.length > 0) {
      output.push({
        code: 'address.incomplete',
        message: 'Het adres is onvolledig. Niet alle velden zijn ingevuld',
        properties: errors.incomplete
      });
    }
    this.$scope.$emit('onErrorsChanged', {
      key: this.sKey || makeid(),
      errors: output
    });
    if (!initialisationPhase && (output.length === 0 || !this.focus)) {
      if(!this.address.zipCode && !this.address.subCity && !this.address.street && !this.address.houseNumber) {
        this.$scope.$emit('addressChanged', null);
      } else if (errors.incomplete.length === 0) {
        this.$scope.$emit('addressChanged', this.address);
      }
    }
    if(applyScope) {
      this.$scope.$apply();
    }
  }

  isIncomplete(property) {
    return !this.focus && this.errors.incomplete.some(inc => inc === property);
  }

  zipCodeKeyPressed() {
    this.zipCodeTyping = true;
  }
  zipCodeNeedsAttention() {
    return !this.zipCodeTyping && (this.sEditMode || this.sSubmitAttempted || this.zipCodeDirty);
  }
  houseNumberKeyPressed() {
    this.houseNumberTyping = true;
  }
  houseNumberNeedsAttention() {
    return !this.houseNumberTyping && (this.sEditMode || this.sSubmitAttempted || this.houseNumberDirty);
  }
  mailboxNumerKeyPressed() {
    this.mailboxNumerTyping = true;
  }
  mailboxNumberNeedsAttention() {
    return !this.mailboxNumberTyping && (this.sEditMode || this.sSubmitAttempted || this.mailboxNumberDirty);
  }

  needsAttention(property) {
    //return !this.isTyping && (this.sEditMode || this.sSubmitAttempted || this.dirty);
    return this.focus !== property;
  }

  onForeignZipCodeChange() {
    this.zipCodeTyping = false;
    this.zipCodeDirty = true;
    this.validate();
  }
  onForeignCityBlur() {
    this.focus = null;
  }
  onForeignCityFocus() {
    this.focus = 'foreignCity';
  }
  foreignCityKeyPressed() {
    this.foreignCityTyping = true;
  }
  foreignCityNeedsAttention() {
    return !this.foreignCityTyping && (this.sEditMode || this.sSubmitAttempted || this.foreignCityDirty);
  }
  onForeignCityChange() {
    this.foreignCityTyping = false;
    this.foreignCityDirty = true;
    this.validate()
  }
  onForeignStreetChange() {
    this.foreignStreetTyping = false;
    this.foreignStreetDirty = true;
    this.validate();
  }
}

module.exports = {
  template: require('./kovAddressForm.html'),
  controllerAs: 'ctrl',
  controller: KovAddressForm,
  transclude: false,
  bindings: {
    sKey: '@',
    sAddress: '<',
    sDisabled: '<',
    sSriClient: '<',
    sPickCountry: '<',
    sEditMode: '<',
    sStoreStreetHref: '<',
  }
};
